import { pathJoin } from 'src/reducers/routing/utils'

export const createWarehouseRouteMap = (prefix: string) => ({
  balances: pathJoin(prefix)('balances').chain,
  containers: pathJoin(prefix)('containers').chain,
  'in-storage': pathJoin(prefix)('in-storage').chain,
  movements: pathJoin(prefix)('movements').chain,
  // PRO-975: supplier purchase orders into this warehouse.
  'purchase-orders': pathJoin(prefix)('purchase-orders').chain,
  rental: pathJoin(prefix)('rental').chain,
  settings: pathJoin(prefix)('settings').chain,
})
